import type { BaseModelLiteData, ProductFamilyBasicData, StoreContext } from '../data/model';
import { IEvent } from '../shared/EventAggregator';

export interface CatalogProduct {
  family: ProductFamilyBasicData;
  model?: BaseModelLiteData;
}

export class ProductListViewedEvent implements IEvent {
  constructor(
    public readonly storeContext: StoreContext,
    public readonly products: CatalogProduct[],
    public readonly startIndex: number,
  ) {}
}

export class ProductSelectedEvent implements IEvent {
  constructor(
    public readonly storeContext: StoreContext,
    public readonly product: CatalogProduct,
    public readonly startIndex: number,
    public readonly index: number,
  ) {}
}
